/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ZapierConnection model module.
 * @module model/ZapierConnection
 * @version V1
 */
class ZapierConnection {
    /**
     * Constructs a new <code>ZapierConnection</code>.
     * @alias module:model/ZapierConnection
     */
    constructor() { 
        
        ZapierConnection.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ZapierConnection</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ZapierConnection} obj Optional instance to populate.
     * @return {module:model/ZapierConnection} The populated <code>ZapierConnection</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ZapierConnection();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('connectionName')) {
                obj['connectionName'] = ApiClient.convertToType(data['connectionName'], 'String');
            }
            if (data.hasOwnProperty('creationDate')) {
                obj['creationDate'] = ApiClient.convertToType(data['creationDate'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ZapierConnection</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ZapierConnection</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['connectionName'] && !(typeof data['connectionName'] === 'string' || data['connectionName'] instanceof String)) {
            throw new Error("Expected the field `connectionName` to be a primitive type in the JSON string but got " + data['connectionName']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
ZapierConnection.prototype['id'] = undefined;

/**
 * @member {String} connectionName
 */
ZapierConnection.prototype['connectionName'] = undefined;

/**
 * @member {Date} creationDate
 */
ZapierConnection.prototype['creationDate'] = undefined;






export default ZapierConnection;

